import PropTypes from 'prop-types'
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import moment from 'moment'
import AttachFunds from './AttachFunds'

const SchedulerNotOpen = ({
  schedulerAccessDate,
  noAccessForManagers,
  eventId,
  onRefresh,
}) => {
  const text = noAccessForManagers ? (
    <>
      <div className="pb-4">
        You have not yet specified which funds you will be presenting at this
        event.
      </div>
      <div>
        Please use the <b>Add Funds</b> button above to select the funds.
      </div>
    </>
  ) : moment(schedulerAccessDate).isValid() ? (
    `Summit's Schedule will open on ${moment
      .utc(schedulerAccessDate)
      .local()
      .format('MMMM DD, YYYY [at] h:mm A')}`
  ) : (
    "Summit's Schedule is not opened yet."
  )

  return (
    <div
      className="flex flex-col text-center m-8"
      style={
        {
          //display: 'flex',
          //alignContent: 'center',
          //flexDirection: 'column',
          //width: '40%',
        }
      }
    >
      <div style={{ textAlign: 'center', margin: '40px 24px' }}>
        <FontAwesomeIcon
          className="cc-text-color-summit"
          size="4x"
          icon={faInfoCircle}
        />
      </div>
      <div className="cc-lightblack-text text-left leading-24">{text}</div>
      {/* <div
        style={{ textAlign: 'center', marginTop: '16px', marginBottom: '40px' }}
        className="cc-body-text cc-dark-grey-text"
      >
        {noAccessForManagers ? (
          <AttachFunds
            eventId={eventId}
            onRefresh={onRefresh}
          />
        ) : (
          'You will be able to view attendees and send meeting requests once the schedule is opened'
        )}
      </div> */}
    </div>
  )
}

SchedulerNotOpen.propTypes = {
  schedulerAccessDate: PropTypes.instanceOf(Date),
  noAccessForManagers: PropTypes.bool.isRequired,
  eventId: PropTypes.number.isRequired,
  onRefresh: PropTypes.func.isRequired,
}

export default SchedulerNotOpen
